import ApiService from "../../../services/ApiService";

const WordWheelSocialDraftService = {
    requestLatest: async () => {
        const json = await ApiService.getData("/v1/puzzle/wordwheel-social/latest");
        if (!json || json.code === "NO_DATA" || json.code === "FAILURE") {
            return null;
        }
        if (!json.imageUrl && !json.caption) {
            return null;
        }
        return json;
    },

    markPosted: async ({ id, puzzleId, word, maskedWord, facebookPostId }) => {
        const json = await ApiService.postData("/v1/puzzle/wordwheel-social/mark-posted", {
            id,
            puzzleId,
            word,
            maskedWord,
            facebookPostId,
        });
        if (!json || json.code === "FAILURE") {
            throw new Error(json?.message || "Failed to mark Facebook post");
        }
        return json;
    },
};

export default WordWheelSocialDraftService;
